if (!customElements.get('sw-raumduft-offers')) {
  customElements.define('sw-raumduft-offers', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.planInput = this.querySelector('[data-rd-selling-plan]');
      this.button = this.querySelector('[data-rd-submit]');
      this.selectedPlan = '';
      this.busy = false;
      this.setAttribute('data-rd-ready', '');
      this.addEventListener('change', event => {
        if (event.target.matches('[data-rd-mode]')) this.selectedPlan = event.target.value;
        if (event.target.matches('[data-rd-variant], [data-rd-mode]')) this.sync();
      }, { signal: this.abort.signal });
      this.form.addEventListener('submit', event => this.addToCart(event), { signal: this.abort.signal });
      this.button?.addEventListener('click', event => this.addToCart(event), { signal: this.abort.signal });
      this.sync();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
    }
    sync() {
      const variant = this.querySelector('[data-rd-variant]:checked') || this.querySelector('select[data-rd-variant]');
      const variantId = variant?.value;
      let mode;
      this.querySelectorAll('[data-rd-plans-for]').forEach(panel => {
        const active = panel.dataset.rdPlansFor === variantId;
        panel.hidden = !active;
        const inputs = [...panel.querySelectorAll('[data-rd-mode]')];
        inputs.forEach(input => { input.disabled = !active; });
        if (active) {
          mode = inputs.find(input => input.value === this.selectedPlan) || inputs.find(input => input.value === '') || inputs[0];
          if (mode) mode.checked = true;
        }
      });
      this.selectedPlan = mode?.value || '';
      this.planInput.value = this.selectedPlan;
      this.planInput.disabled = !this.selectedPlan;
      this.querySelectorAll('[data-rd-subscription-note]').forEach(note => { note.hidden = !this.selectedPlan; });
      const price = mode?.dataset.price || variant?.selectedOptions?.[0]?.dataset.price || variant?.dataset.price || variant?.closest('label')?.querySelector('.sw-rd__offer-price strong')?.textContent;
      this.querySelectorAll('[data-rd-total]').forEach(total => { if (price) total.textContent = price; });
      if (this.button) {
        const available = Boolean(variantId) && !variant.disabled && !variant.selectedOptions?.[0]?.disabled;
        this.button.disabled = !available || this.busy;
        this.button.querySelector('[data-rd-button-text]').textContent = available ? (this.selectedPlan ? this.button.dataset.subscription : this.button.dataset.oneTime) : this.dataset.soldOut;
      }
    }
    async addToCart(event) {
      event.preventDefault();
      if (this.busy || !this.button || this.button.disabled) return;
      this.sync();
      if (this.button.disabled) return;
      this.busy = true;
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      const error = this.querySelector('[data-rd-error]');
      if (error) error.hidden = true;
      try {
        const selectedVariant = this.querySelector('[data-rd-variant]:checked') || this.querySelector('select[data-rd-variant]');
        const selectedMode = this.querySelector('[data-rd-plans-for]:not([hidden]) [data-rd-mode]:checked');
        const item = { id: Number(selectedVariant.value), quantity: 1 };
        if (selectedMode?.value) item.selling_plan = Number(selectedMode.value);
        const product = await new Promise((resolve, reject) => {
          const request = new XMLHttpRequest();
          request.open('POST', this.form.action + '.js');
          request.setRequestHeader('Content-Type', 'application/json');
          request.setRequestHeader('Accept', 'application/json');
          request.timeout = 20000;
          request.onload = () => {
            try {
              const result = JSON.parse(request.responseText);
              if (request.status < 200 || request.status >= 300 || result.status >= 400) reject(new Error(result.description || this.dataset.error));
              else resolve(result);
            } catch { reject(new Error(this.dataset.error)); }
          };
          request.onerror = request.ontimeout = () => reject(new Error(this.dataset.error));
          request.send(JSON.stringify({ items: [item] }));
        });
        if (!document.getElementById('sw-cart-drawer')) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product, addToCartBtn: this.button } }));
        }
        if (!document.getElementById('CartDrawer') && !document.getElementById('sw-cart-drawer')) {
          window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
        }
      } catch (failure) {
        if (error) {
          error.textContent = failure instanceof TypeError ? this.dataset.error : (failure.message || this.dataset.error);
          error.hidden = false;
        }
      } finally {
        this.busy = false;
        this.button.removeAttribute('aria-busy');
        this.sync();
      }
    }
  });
}

